// Update your Badges component to handle the color prop
export default function Badges({ content, color }) {
  return (
    <span
      className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium mr-2"
      style={{
        backgroundColor: color ? `#${color}` : "#2D536F",
        color: "#FFFFFF",
      }}
    >
      {content}
    </span>
  );
}
